import { Button } from 'antd'
import { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { QboItem, QboLinkResult } from '../../domain/quickbooks/quickbooksModel'
import {
  useQboItemsQuery,
  useLinkCostCodeToQboMutation,
} from '../../domain/quickbooks/quickbooksQueries'
import QboEntityPickerModal from './QboEntityPickerModal'

type Props = {
  costCodeId: number | undefined
  showUpdateDetails?: boolean
  onSuccess: (result: QboLinkResult & { updateDetails: boolean }) => void
  onClose: () => void
}

const LinkCostCodeToQuickBooks = ({
  costCodeId,
  showUpdateDetails = true,
  onSuccess,
  onClose,
}: Props) => {
  const open = costCodeId !== undefined
  const [selectedItem, setSelectedItem] = useState<QboItem | null>(null)

  const { data: qboItems, isLoading, refetch } = useQboItemsQuery()

  const linkMutation = useLinkCostCodeToQboMutation()

  useEffect(() => {
    if (!open) {
      setSelectedItem(null)
    }
  }, [open])

  const handleLink = (updateDetails: boolean) => {
    if (!selectedItem || costCodeId === undefined) return
    linkMutation.mutate(
      {
        id: costCodeId,
        qboId: selectedItem.id,
        qboDisplayName: updateDetails ? selectedItem.displayName : undefined,
      },
      {
        onSuccess: () => {
          onSuccess({
            qboId: selectedItem.id,
            qboDisplayName: selectedItem.displayName,
            updateDetails,
          })
          onClose()
        },
      }
    )
  }

  return (
    <QboEntityPickerModal
      open={open}
      onCancel={onClose}
      title="Cost Code QuickBooks Link"
      searchPlaceholder="search QuickBooks items..."
      items={qboItems}
      isLoading={isLoading}
      selectedItemId={selectedItem?.id}
      onSelectItem={setSelectedItem}
      renderItemLabel={(item) => <span>{item.displayName}</span>}
      footerExtra={
        <>
          <Button
            onClick={() => handleLink(false)}
            disabled={!selectedItem || linkMutation.isLoading}
            loading={linkMutation.isLoading}
            icon={<FontAwesomeIcon icon={faCheck} />}
          >
            Link
          </Button>
          {showUpdateDetails && (
            <Button
              type="primary"
              onClick={() => handleLink(true)}
              disabled={!selectedItem || linkMutation.isLoading}
              loading={linkMutation.isLoading}
              icon={<FontAwesomeIcon icon={faCheck} />}
            >
              Link & Update Info
            </Button>
          )}
        </>
      }
      onOpen={() => refetch()}
    />
  )
}

export default LinkCostCodeToQuickBooks
